const getRealUpchargePrice = (upchargePrice: string | number): number | null => {
  let realUpchargePrice: any = (String(upchargePrice).match(/\d+(?:\.\d+)?/) || [])[0]

  if (realUpchargePrice) {
    realUpchargePrice = parseFloat(realUpchargePrice) / 100
  }

  return realUpchargePrice || null
}


export default getRealUpchargePrice
